import { ActionsObservable, StateObservable, ofType } from 'redux-observable';
import {
  catchError, map, mergeMap, withLatestFrom,
} from 'rxjs/operators';
import serializeTeam from '../../utils/serializers/serializeTeam';
import { FETCH_TEAM_ERROR, FETCH_TEAM_REQUEST } from '../../constants/actionTypes';
import { FetchTeamRequestAction } from '../../models/actions';
import { Response } from '../../models/Response';
import { Team } from '../../models/Team';
import { State } from '../../models/State';
import { TEAM_PATH } from '../../constants/paths';
import { fetchTeamError, fetchTeamSuccess } from '../../actions/teams';
import { handleError } from '../../actions/errors';

export default (
  action$: ActionsObservable<FetchTeamRequestAction>,
  state$: StateObservable<State>,
  { ajax }: any,
) => action$.pipe(
  ofType(FETCH_TEAM_REQUEST),
  withLatestFrom(state$),
  mergeMap(([
    { payload: { id } },
    {
      authentication: { authToken },
      application: { clubId },
    },
  ]) => ajax({
    url: `${TEAM_PATH
      .replace('$clubId', `${clubId}`)}`
      .replace('$teamId', `${id}`),
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authToken,
    },
  }).pipe(
    map(({ response: team }: Response<Team>) => serializeTeam(team)),
    map(fetchTeamSuccess),
    catchError(error => [
      handleError(error, FETCH_TEAM_ERROR),
      fetchTeamError(error),
    ]),
  )),
);
